var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{ 'safety-assistant': _vm.safetyAssistant }},[_c('h2',{staticClass:"heading mt-2 mb-2"},[_vm._v(_vm._s(_vm.title))]),_c('p',{class:['subheading', 'mt-2', _vm.message ? 'mb-4' : 'mb-8']},[_vm._v(" "+_vm._s(_vm.subtitle)+" ")]),(_vm.message)?_c('div',{staticClass:"mb-5 darkRed--text"},[_vm._v(_vm._s(_vm.message))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }